import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Navbar from "./Components/Navbar";
import Features from "./Components/Home";
import About from "./Components/About";
import Contact from "./Components/Contact";
import ParentsLove from "./Components/ParentsLove";
import Footer from "./Components/Footer";


function App() {
  return (
    <Router>
      <Navbar />
        <Routes>
          <Route path="/" element={<Features />} />
        <Route path="/Gift" element={<About />} />
          <Route path="/Contact" element={<Contact/>} />
          <Route path="/News" element={<ParentsLove/>} />
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
